import * as React from 'react'
import { Subhead, Flex } from 'rebass'
import Link from 'gatsby-link'
import WordShuffle from './WordShuffle'
import styled from 'styled-components'
import * as ReshuffleIcon from 'react-icons/lib/ti/arrow-loop'

const BlurbContainer = styled(Flex)`
  overflow: hidden;
  svg {
    transition: transform 0.5s cubic-bezier(0.1, 1.1, 0, 1.01);
    transform: translateX(300px);
  }
  &:hover {
    svg {
      transition: transform 0.5s cubic-bezier(0.1, 1.1, 0, 1.01);
      transform: translateX(0px);
    }
  }
`
const getRandomElement = arr => {
  const randIdx = Math.ceil(Math.random() * arr.length) - 1
  const ele = arr[randIdx]
  return ele
}

const ReshuffleButton = (props: { onClick: () => void }) => (
  <ReshuffleIcon
    style={{ cursor: 'pointer' }}
    size={30}
    onClick={props.onClick}
  />
)

class Logo extends React.PureComponent<{}, { blurb: string }> {
  constructor(props: {}) {
    super(props)
    this.state = {
      blurb: getRandomElement(this.titles),
    }
    this.setRandomBlurb = this.setRandomBlurb.bind(this)
  }
  titles = [
    'The 34,743,259th wonder of the world.',
    "America's 435,213rd line of defense.",
    "The man the Economist once called 'subscriber.'",
    "A man so well-rounded, he doesn't have a point.",
  ]
  setRandomBlurb() {
    let newBlurb = this.state.blurb
    while (newBlurb === this.state.blurb) {
      newBlurb = getRandomElement(this.titles)
    }
    this.setState({ blurb: newBlurb })
  }

  render() {
    return (
      <Flex
        flexDirection={'column'}
        alignItems={['center', 'center', 'flex-start', 'flex-start']}
      >
        <Link to={'/'}>
          <Subhead mb={0}>brandon paquette</Subhead>
        </Link>
        <BlurbContainer
          flexWrap={false}
          fontSize={2}
          ml={[40, 40, 0, 0]}
          style={{ lineHeight: '110%', fontWeight: 300 }}
        >
          <i>
            <WordShuffle
              style={{ maxWidth: '200px' }}
              speed={40}
              word={this.state.blurb}
            />
          </i>
          <ReshuffleButton onClick={this.setRandomBlurb} />
        </BlurbContainer>
      </Flex>
    )
  }
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo.tsx